export default __webpack_public_path__ + "static/media/Task Groups.339c54fd.jpg";